import SkeletonTable from "@/components/SkeletonTable"
import api from "@/lib/axios"
import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import { Link, useLocation } from "react-router-dom"

const listMenu = [
  {
    name: "Jalur Feeder",
    path: "/admin/master/jalur-feeder",
  },
  {
    name: "Jenis Daftar Feeder",
    path: "/admin/master/jalur-feeder/jenis-daftar-feeder",
  },
]

const getListJenisDaftarFeeder = async () => {
  const response = await api.get("/master/feeder/jenis-daftar", {
    withCredentials: true,
  })
  return response.data?.data
}

export default function MasterJenisDaftarFeederPage() {
  const { pathname } = useLocation()

  const { data, isPending } = useQuery({
    queryKey: ["listJenisDaftarFeeder"],
    queryFn: getListJenisDaftarFeeder,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <div className="rounded-full border overflow-hidden flex w-fit">
        {listMenu.map((menu, index) => {
          const active = menu.path === pathname
          return (
            <Link
              key={index}
              to={menu.path}
              className={`py-2 px-3  ${
                active
                  ? `bg-black text-white ${
                      index === 0
                        ? "rounded-r-full"
                        : index === listMenu.length
                        ? "rounded-l-full"
                        : "rounded-full"
                    }`
                  : "hover:bg-secondary cursor-pointer"
              }`}
            >
              <span className="font-semibold text-sm">{menu.name}</span>
            </Link>
          )
        })}
      </div>

      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
